import { useState, useEffect } from 'react';
// import { useState, useEffect } from 'react';
import { useConfig } from '../context/ConfigContext';
import { useAuth } from '../context/AuthContext.jsx';
import axios from 'axios';

const reactions = [
  { type: 'FIRE', emoji: '🔥' },
  { type: 'PRETTY', emoji: '😍' },
  { type: 'UNIQUE', emoji: '🌟' },
];


function ReactButton({ itemType, itemId, hasReactedInitial, reactCountInitial, userId, prettyReactionsCount, fireReactionsCount, uniqueReactionsCount }) {
	const { token } = useAuth();
    const { backendApiBaseUrl } = useConfig();
    const [selectedReaction, setSelectedReaction] = useState(hasReactedInitial);
    const [reactCount, setReactCount] = useState(reactCountInitial);
	const [showOptions, setShowOptions] = useState(false);
	const [fireCount, setFireCount] = useState(fireReactionsCount);
	const [prettyCount, setPrettyCount] = useState(prettyReactionsCount);
	const [uniqueCount, setUniqueCount] = useState(uniqueReactionsCount);

    const parseItemId = (itemKey) => {   
        if (typeof itemKey === 'string' && itemKey.includes('-')) {
            const [type, itemID] = itemKey.split('-');
            return { type, itemID: parseInt(itemID, 10) };
        } else {
            return { type: undefined, itemID: parseInt(itemKey, 10) };
        }
    };

	const handleReaction = async (reactionType) => {
		if (!userId) return;

		const { type, itemID } = parseItemId(itemId);
		const prevReaction = selectedReaction;

		try {
			// CASE 1: No reaction yet → ADD
			if (!prevReaction) {
				await axios.post(
					`${backendApiBaseUrl}/reactions`,
					{ itemType, userId, itemID, type, reactionType },
					{ headers: { Authorization: `Bearer ${token.token}` } }
				);

				updateReactionCount(reactionType, 1);
				setReactCount(c => c + 1);
				setSelectedReaction(reactionType);
				return;
			}

			// CASE 2: Same reaction clicked → REMOVE
			if (prevReaction === reactionType) {
				await axios.delete(
					`${backendApiBaseUrl}/reactions`,
					{
						data: { itemType, userId, itemID, type },
						headers: { Authorization: `Bearer ${token.token}` },
					}
				);

				updateReactionCount(prevReaction, -1);
				setReactCount(c => Math.max(0, c - 1));
				setSelectedReaction(null);
				return;
			}

			// CASE 3: Different reaction → CHANGE
			await axios.post(
				`${backendApiBaseUrl}/reactions`,
				{ itemType, userId, itemID, type, reactionType },
				{ headers: { Authorization: `Bearer ${token.token}` } }
			);

			updateReactionCount(prevReaction, -1);
			updateReactionCount(reactionType, 1);
			setSelectedReaction(reactionType);

		} catch (err) {
			console.error("Failed to set reaction", err);
		}
	};


	const updateReactionCount = (type, delta) => {
		switch (type) {
			case 'FIRE': setFireCount(fireCount + delta); break;
			case 'PRETTY': setPrettyCount(prettyCount + delta); break;
			case 'UNIQUE': setUniqueCount(uniqueCount + delta); break;
			default:  break;
		}

	};

	useEffect(() => {
		if (!showOptions) return;

		const timer = setTimeout(() => {
			setShowOptions(false);
		}, 3000);

		return () => clearTimeout(timer);
	}, [showOptions]);

    return (
		<>
			<div onClick={(e) => { e.stopPropagation(); setShowOptions(prev => !prev);; }} 
				style={{ position: 'relative', display: 'inline-block', cursor: 'pointer' }}>
				{!showOptions && (
					<div >
						{selectedReaction ? reactions.find(r => r.type === selectedReaction)?.emoji : <i className="fa-solid fa-plus"></i>}
						<span style={{ marginLeft: '5px' }}>{reactCount}</span>
					</div>
				)}

				{showOptions && (
					<div style={{ position: 'absolute', top: '-2.5rem', left: '0', backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '12px',
						padding: '5px 8px', display: 'flex', gap: '8px', zIndex: 10, boxShadow: '0 2px 8px rgba(0,0,0,0.1)', }} onClick={(e) => e.stopPropagation()}>
					{reactions.map(({ type, emoji }) => {
						const count = {
							FIRE: fireCount,
							PRETTY: prettyCount,
							UNIQUE: uniqueCount,
						}[type] || 0;

						return (
						<div key={type} 
							className='emoji-reactionButton'
							onClick={() => {handleReaction(type); setShowOptions(false);}} 
							style={{ fontSize: '20px', 
							cursor: 'pointer', filter: selectedReaction === type ? 'brightness(1.2)' : 'grayscale(0)', 
							display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: '35px' }}
						>
							{emoji}
							<div style={{ fontSize: '12px', color: '#000000ff', }}>
								{count}
							</div>

						</div>
						);
					})}
					</div>
				)}
			</div>

		</>
    );
}

export default ReactButton;